import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    type: {
      title: 'Typ',
      type: 'string',
      fieldRequired: true
    },
    action: {
      title: 'Akcja',
      type: 'string',
      fieldRequired: true
    },
    actionData: {
      title: 'actionData',
      type: 'string',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
